import FilterDefinitionTypes from './FilterDefinitionTypes';
import ComparisonOperators from './ComparisonTypes';

export const filterArrayBasedOnObj = (filters, array, keyValues) => {
  const filterTypeFilterConfigMap = {};
  const filterKeyValue = { ...keyValues };
  filters.forEach(filter => {
    filterTypeFilterConfigMap[filter.key] = filter;

    if (filter.type === FilterDefinitionTypes.BOOLEAN && typeof filterKeyValue[filter.key] !== 'boolean') {
      delete filterKeyValue[filter.key];
      return;
    }

    if (!filterKeyValue[filter.key] && filter.type !== FilterDefinitionTypes.DATE) {
      delete filterKeyValue[filter.key];
    }
  });

  if (!Object.keys(filterKeyValue).length) {
    return array;
  }

  const checkIfMatches = (key, filterValue, arrayItem) => {
    const filterObj = filterTypeFilterConfigMap[key] || {};
    const filterType = filterObj.type;
    switch (filterType) {
      case FilterDefinitionTypes.BOOLEAN:
      case FilterDefinitionTypes.VALID_VALUES: {
        const actualValue = arrayItem[key];
        return actualValue === filterValue;
      }
      case FilterDefinitionTypes.DATE: {
        const valueToCheck = arrayItem[filterObj.dateComparisonKey];
        const dateObj = new Date(valueToCheck);
        if (!valueToCheck || !dateObj) {
          return false;
        }
        const filterDate = new Date(filterValue);
        if (filterObj.dateComparisonOperator === ComparisonOperators.GT) {
          return dateObj.getTime() >= filterDate.getTime();
        } else if (filterObj.dateComparisonOperator === ComparisonOperators.LT) {
          return dateObj.getTime() <= filterDate.getTime();
        }
        return true;
      }
      case FilterDefinitionTypes.VALUE:
      default: {
        const actualValue = arrayItem[key];
        return `${actualValue}`.toLowerCase().includes(filterValue.toLowerCase());
      }
    }
  };

  return array.filter(arrayObj => {
    const unmatchIndex = Object.keys(filterKeyValue).findIndex(key => {
      const filterValue = filterKeyValue[key];
      return !checkIfMatches(key, filterValue, arrayObj);
    });
    return unmatchIndex === -1;
  });
};
